module.exports = __webpack_public_path__ + "img/icon_order.ba52f5d8.svg";